import type { ReactNode } from 'react'
import { View, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'

interface Props {
  children: ReactNode
  style?: ViewStyle
  gap?: ViewStyle['gap']
  isRow?: boolean
  radius?: number
}

export function Skeleton({ children, style, gap, isRow }: Props) {
  const styles = useCreateStyles()

  return <View style={[styles.container, style, !!gap && { gap }, isRow && { flexDirection: 'row' }]}>{children}</View>
}
